"use client";

import React from "react";
import { Shield, Hammer, MapPin, ArrowRight, Sparkles } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const pillarsData = [{
  id: "01",
  title: "Licensed & Insured",
  description: "NC General Contractor License #109136. Fully certified, insured, and bonded for complete peace of mind on every residential and commercial project.",
  icon: "shield",
  linkUrl: "/GetAnEstimatePage",
  offsetClass: "mt-0",
  hasHover: false,
  highlightText: "",
  descEnd: ""
}, {
  id: "02",
  title: "Precision Build",
  description: "Our expert teams utilize advanced techniques for roofing, concrete, and remodeling.\xA0",
  icon: "hammer",
  linkUrl: "/GetAnEstimatePage",
  offsetClass: "md:mt-16",
  hasHover: true,
  highlightText: "Project Standards",
  descEnd: " to see how we ensure structural integrity."
}, {
  id: "03",
  title: "Local Expertise",
  description: "Deeply rooted in the Piedmont Triad and Research Triangle, delivering construction solutions tailored to NC climates.",
  icon: "map-pin",
  linkUrl: "/GetAnEstimatePage",
  offsetClass: "md:mt-32",
  hasHover: false,
  highlightText: "",
  descEnd: ""
}];
export default function HolisticHealthPillars() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const renderIcon = (iconName: string) => {
    switch (iconName) {
      case "shield":
        return <Shield className="size-8 text-primary" />;
      case "hammer":
        return <Hammer className="size-8 text-primary" />;
      case "map-pin":
        return <MapPin className="size-8 text-primary" />;
      default:
        return <Sparkles className="size-8 text-primary" />;
    }
  };
  return null;
}